import * as Icons from '../../assets/icons'
import React from 'react'

const MenuIcon = ({ icon, ...props }) => {
    const MyComponent = Icons[icon]
    return <MyComponent {...props} />
}

export default MenuIcon
